import { I18nSchema } from "./I18nSchema";

export const I18nEnglish: I18nSchema = {
  //Navbar
  TITTLE_NAVBAR_MENU_ORDERS: "Orders",
  TITTLE_NAVBAR_MENU_ROUTES: "Routes",
  TITTLE_NAVBAR_MENU_ROUTES_SETTING: "Routes setting",
  TITTLE_NAVBAR_MENU_ANALYTICS: "Analytics",
  TITTLE_NAVBAR_MENU_ANALYTICS_MILEAGE: "Mileage TC",
  TITTLE_NAVBAR_MENU_ANALYTICS_TO_GMC: "TO and GMS",
  TITTLE_NAVBAR_MENU_ANALYTICS_TIME_SLOTS: "Time slots",
  TITTLE_NAVBAR_MENU_SETTING: "Settings",
  TITTLE_NAVBAR_MENU_SETTING_MOBILE_CLIENT: "Transport",
  TITTLE_NAVBAR_MENU_SETTING_DRIVERS: "Drivers",
  TITTLE_NAVBAR_MENU_SETTING_CAR_PARK: "Car park",
  TITTLE_NAVBAR_MENU_SETTING_CLIENT: "Clients",
  TITTLE_HEADER_SEARCH: "Search...",

  //Filters
  TITTLE_FILTER_SEARCH: "Search orders",
  TITTLE_FILTER_DATA: "Filter data",
  TITTLE_FILTER: "Filters",
  TITTLE_FILTER_COLS: "Filter columns",
  TITTLE_FILTER_INTERVAL: "Interval date",
  TITTLE_SELECT_PLACEHOLDER: "Select...",
  TITTLE_NO_OPTIONS_PLACEHOLDER: "No options...",
  TITLE_PAGINATION_TABLE_TOTAL_COLUMN: "Total",
  PAGINATION_OF_TITLE: "of",
  TITTLE_REQUIRED: "Field is required!",
  TITLE_ACTION_TABLE: "Actions",

  //Home
  TITTLE_HOME_LIST_OF_ORDERS: "List of orders",
  TITTLE_ORDERS_CREATE_ORDER_MODAL_HEADER: "Create new order",
  TITTLE_ORDER_MODAL_CLIENT: "Client",
  TITTLE_ORDER_MODAL_COMPANY: "Сourier product",
  TITTLE_ORDER_MODAL_NAME_SENDER: "Sender name",
  TITTLE_ORDER_MODAL_NAME_RECEIVER: "Receiver name",

  //Buttons
  TITTLE_BTN_ADD: "Add",
  TITTLE_ADD_ZONE: "Add zone",
  TITTLE_ADD_OBJECT: "Add facility",
  TITTLE_ZONE: "Zone",
  TITTLE_LOCATION_OBJECT: "Location of facilities",
  TITTLE_ROUTES_PAGE_CREATE_ROUTES_BTN: "Create route",
  TITTLE_ROUTES_PAGE_SPEND: "Spend",
  TITTLE_RELOAD_DATA_FILTER: "Reload data",
  TITTLE_FULLSCREEN_FILTER: "Fullscreen",
  TITTLE_DOWNLOAD_FILTER: "Download",
  TITTLE_PRINT_FILTER: "Print",
  TITLE_ACCEPT_BTN: "Accept",
  TITLE_CANCEL_BTN: "Cancel",

  //Routes
  TITTLE_ROUTES_PAGE_ROUTES: "Routes",
  TITTLE_ROUTES_PAGE_SHOW_ALL: "Show all",
  TITTLE_ROUTES_PAGE_SHOW_UNALLOCATED: "Show unallocated",
  TITTLE_ROUTES_PAGE_RESET_ALL: "Reset all",

  //Routes Setting
  TITTLE_ROUTES_SETTING_SWITCH_MAP: "Maps",
  TITTLE_ROUTES_SETTING_SWITCH_TARRIFS: "Tariffs",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_ROUTES: "Routing time",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_DELIVERY: "Delivery",
  TITTLE_ROUTES_SETTING_SWITCH_SETTING: "Build parameters",

  //Login
  TITTLE_LOGIN_WELCOME_BACK: "Welcome back !",
  TITTLE_LOGIN_SIGN_IN_TO: "Sign in to continue to Sello logistics",
  TITTLE_LOGIN_EMAIL: "Phone number",
  TITTLE_LOGIN_FORGET_PASSWORD: "Forget password ?",
  TITTLE_LOGIN_PASSWORD: "Password",
  TITTLE_LOGIN_REMEMBER_ME: "Remember me",
  TITTLE_LOGIN_SIGN_IN: "Sign in",
  TITTLE_LOGIN_DONT_HAVE_ACCOUNT: "Don't have an account ?",
  TITTLE_LOGIN_SIGN_UP: "Sign up",
  TITTLE_LOGIN_FOOTER: "Sello Logistics. Crafted with",
  TITTLE_LOGIN_FOOTER2: "by Tune Consulting",

  //Forget Password
  TITTLE_FORGOT_PASSWORD_ENTER_EMAIL: "Enter your email and instructions will be sent to you!",
  TITTLE_FORGOT_PASSWORD_MAIN: "Forgot password ?",
  TITTLE_FORGOT_PASSWORD_SEND_RESET: "Send Reset Link",
  TITTLE_FORGOT_PASSWORD_I_REMEMBER: "Wait, I remember my password...",
  TITTLE_FORGOT_CLICK_HERE: "Click here",
  TITTLE_FORGOT_RESET_PASSWORD_WITH: "Reset password with Sello Logistics",

  //DRIVER
  TITTLE_EDIT_MODAL_DRIVER: "Edit driver",
  TITTLE_ADD_MODAL_DRIVER: "Add driver",
  TITTLE_PRODUCER_MODAL_DRIVER: "Manufacturer",
  TITTLE_MODEL_MODAL_DRIVER: "Model",
  TITTLE_TYPE_OF_CAR_MODAL_DRIVER: "Vehicle type",
  TITTLE_TYPE_MODAL_DRIVER: "Body type",
  TITTLE_COLOR_MODAL_DRIVER: "Color",
  TITTLE_REGISTER_YEAR_MODAL_DRIVER: "Manufacture year",
  TITTLE_LICENSE_PLATE_MODAL_DRIVER: "Plate number",
  TITTLE_STATUS_MODAL_DRIVER: "Status",
  TITTLE_COURIER_COMPANY_MODAL_DRIVER: "Courier product",
  TITTLE_DRIVER_MODAL_DRIVER: "Driver",
  TITTLE_CAR_LENGTH_DRIVER: "Length in kg",
  TITTLE_CAR_WIDTH_DRIVER: "Width in kg",
  TITTLE_CAR_HEIGHT_DRIVER: "Height in kg",

  //NAVBAR
  TITTLE_NAVBAR_MENU_MONITORING: "Monitoring",
  TITTLE_NAVBAR_MENU_PRODUCTS: "Products",
  TITTLE_NAVBAR_MENU_SHIPMENT: "Shipment",
  TITTLE_NAVBAR_MENU_STAFF: "Staff",
  TITTLE_NAVBAR_MENU_SETTINGS: "Settings",
  TITTLE_NAVBAR_MENU_MONITORING_ORDERS: "Orders",
  TITTLE_NAVBAR_MENU_MONITORING_REMAINS: "Remains",
  TITTLE_NAVBAR_MENU_MONITORING_HISTORY_CASHBOX: "History of cashbox",
  TITTLE_NAVBAR_MENU_MONITORING_LOAD_ORDERS: "Load orders",
  TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE: "Acceptance",
  TITTLE_NAVBAR_MENU_PRODUCTS_MARKING: "Marking",
  TITTLE_NAVBAR_MENU_PRODUCTS_TRAFFIC: "Traffic",
  TITTLE_NAVBAR_MENU_PRODUCTS_EQUIPMENT: "Equipment",
  TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE: "Storage",
  TITTLE_NAVBAR_MENU_PRODUCTS_ZONES: "Zones",
  TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT: "Movement",
  TITTLE_NAVBAR_MENU_PRODUCTS_INVENTORY: "Invertory",
  TITTLE_NAVBAR_MENU_PRODUCTS_PRODUCT_CARDS: "Product cards",
  TITTLE_NAVBAR_MENU_STAFF_SHIFTS: "Shifts",
  TITTLE_NAVBAR_MENU_STAFF_PERMISSIONS: "Permissions",
  TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX: "Cashbox",
  TITTLE_NAVBAR_MENU_SHIPMENT_ISSUE_CLIENT: "Issue of client",
  TITTLE_NAVBAR_MENU_SHIPMENT_RETURN: "Return",
  TITTLE_NAVBAR_MENU_SETTINGS_ADDRESS_STORAGE: "Adress storage",
  TITTLE_NAVBAR_MENU_SETTINGS_SETTING_RC: "Setting rc",
  TITTLE_NAVBAR_MENU_SETTINGS_EMPLOYEES: "Employees",

  //PRODUCTS
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_ARRIVAL: "Outfits for arrival",
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_SHIPMENT: "Outfits for leaving",
  TITTLE_PRODUCTS_ACCEPTANCE_GOODS_TO_ARRIVAL: "Goods to arrival",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ARRIVAL: "Arrival",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SUPPLIER: "Supplier",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_AGREEMENT: "Agreement",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PERFORMING_COMPANY: "Performing product",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_VEHICLE: "Vehicle",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_HAND_OVER: "Hand over",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ACCEPTED: "Accepted",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SEND_TO_1C: "Send to 1c",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PRINT: "Print",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SAVE: "Save",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SCAN_YK_PRODUCTS: "Scan YK products",
};
